<template>
    <div>
        <div class="imposto-div-retencao">
            <b-row>
                <b-col sm="2">
                    <CheckboxSimple title="Reter ISS" :disabled="disabled" v-model="imposto.issRetido" />
                </b-col>
                <b-col sm="2" v-if="!ehSimplesNacional">
                    <CheckboxSimple title="Reter PIS/COFINS" :disabled="disabled" v-model="imposto.pisCofinsRetido" />
                </b-col>
            </b-row>
        </div>
        <b-row>
            <b-col sm="2">
                <InputNumber title="Alíquota ISS %" field="aliquota" type="float" :formName="formName" :required="false"
                    :maxLength="9" :disabled="disabled" v-model="imposto.issAliquota" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputNumber title="Alíquota PIS %" field="aliquota" type="float" :formName="formName" :required="false"
                    :maxLength="9" :disabled="disabled" v-model="imposto.pisAliquota" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputNumber title="Alíquota COFINS %" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="disabled" v-model="imposto.cofinsAliquota" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputNumber title="Alíquota CSLL %" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="disabled" v-model="imposto.csllAliquota" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputNumber title="Alíquota IR %" field="aliquota" type="float" :formName="formName" :required="false"
                    :maxLength="9" :disabled="disabled" v-model="imposto.irAliquota" />
            </b-col>
        </b-row>
        <b-row v-if="id">
            <b-col sm="2">
                <InputDecimal title="Valor ISS" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="true" v-model="imposto.issValor" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputDecimal title="Valor PIS" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="true" v-model="imposto.pisValor" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputDecimal title="Valor COFINS" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="true" v-model="imposto.cofinsValor" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputDecimal title="Valor CSLL" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="true" v-model="imposto.csllValor" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputDecimal title="Valor IR" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="true" v-model="imposto.irValor" />
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputNumber title="Alíquota IBS %" field="aliquota" type="float" :formName="formName" :required="false"
                    :maxLength="9" :disabled="disabled" v-model="imposto.ibsAliquota" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputNumber title="Alíquota CBS %" field="aliquota" type="float" :formName="formName" :required="false"
                    :maxLength="9" :disabled="disabled" v-model="imposto.cbsAliquota" />
            </b-col>
        </b-row>
    </div>
</template>

<script>

import CheckboxSimple from "@nixweb/nixloc-ui/src/component/forms/CheckboxSimple";
import InputDecimal from "@nixweb/nixloc-ui/src/component/forms/InputDecimal";
import InputNumber from "@nixweb/nixloc-ui/src/component/forms/InputNumber";

import NfseNacional from "./NfseNacional.js";

import { mapActions } from "vuex";

export default {
    name: "Impostos",
    props: ["formName", "ehSimplesNacional", "disabled", "value"],
    components: {
        CheckboxSimple, InputDecimal, InputNumber
    },
    data() {
        return {
            id: this.$route.params.id,
            imposto: new NfseNacional().imposto,
            urlGetById: "/api/v1/tax-document/config-company/get-by-id",
            loading: false,
        }
    },
    mounted() {
        if (!this.id) this.obterRegimeTributarioEmpresa();
    },
    methods: {
        ...mapActions("generic", ["getApi"]),
        obterRegimeTributarioEmpresa() {
            this.loading = true;
            let params = { url: this.urlGetById, obj: {} };
            this.getApi(params).then((response) => {
                if (response && response.success) {
                    const data = response.content || {};

                    const simples = data.simplesNacional === true
                        || data.simplesNacional === "Sim"
                        || data.simplesNacional === 1
                        || data.simplesNacional === "1";

                    this.ehSimplesNacional = !!simples;

                    this.imposto.issAliquota = data.iss || 0;
                    this.imposto.ibsAliquota = data.ibs || 0;
                    this.imposto.cbsAliquota = data.cbs || 0;

                    if (!this.ehSimplesNacional) {
                        this.imposto.pisAliquota = data.pis || 0;
                        this.imposto.cofinsAliquota = data.cofins || 0;
                        this.imposto.csllAliquota = data.csll || 0;
                        this.imposto.irAliquota = data.ir || 0;
                    } else {
                        this.imposto.pisAliquota = 0;
                        this.imposto.cofinsAliquota = 0;
                        this.imposto.csllAliquota = 0;
                        this.imposto.irAliquota = 0;
                    }
                }
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    watch: {
        value: {
            deep: true,
            handler(value) {
                if (this.id) this.imposto = value;
            }
        },
        imposto: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal);
            }
        }
    },
}
</script>
<style scoped>
.imposto-div-retencao {
    margin-bottom: 10px;
}
</style>